// =====================================================================
//  Profil d'envoi d'un client — routes proxy :
//    GET /profilmail/{clientId}  (clé masquée)
//    PUT /profilmail             (clé vide = inchangée)
// =====================================================================

import {JsonFetchJson} from "../../Helper/FetchHelper.js";
import {ResponseApi} from "../../Model/ResponseApi.js";
import {IProfilMailModel} from "../../Model/Client/ProfilMalModel.js";
import {NotificationHelper} from "../../Helper/NotificationHelper.js";

export class ProfilMail {
    /** Profil du client, ou null s'il n'en a pas encore. */
    public static Read = async (clientId: string): Promise<IProfilMailModel | null> => {
        const response = await JsonFetchJson.Get<ResponseApi<IProfilMailModel | null>>(`/profilmail/${clientId}`);
        return response?.Data ?? null;
    };

    /** Enregistre le profil ; renvoie le profil masqué, ou null en cas d'erreur (déjà notifiée). */
    public static Upsert = async (model: IProfilMailModel): Promise<IProfilMailModel | null> => {
        const response = await JsonFetchJson.Put<ResponseApi<IProfilMailModel>>("/profilmail", model);
        if (!response?.Data) {
            // Erreurs de validation : déjà notifiées par FetchAbstract.checkResponseApi.
            if (!response?.HasError)
                NotificationHelper.Instance.error("Le profil d'envoi n'a pas pu être enregistré.");
            return null;
        }
        return response.Data;
    };
}
